// extracted by mini-css-extract-plugin
export default {"home":"Home_home__xnITb","bio":"Home_bio__6rIn0","services":"Home_services__sufcI","homeServices":"Home_homeServices__kFNRJ","whatDesc":"Home_whatDesc__tiXnH"};